
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'fab-button',
    props: {
        icon: String
    }
})
